import React from 'react';
import { ClientFooter } from '@ecosystem/newron-client-lib';
import { useCorePageState } from './provider';
import { NEWRON_CORE_VERSION } from '../common/constants/version';

const formatVersionString = (appVersion?: string) => {
  return (appVersion ? `${appVersion} (` : '') + `core: ${NEWRON_CORE_VERSION}` + (appVersion ? ')' : '');
};

const PageFooter: React.FC<{ className?: string }> = ({ className }) => {
  const {
    page: { appVersion },
  } = useCorePageState();

  return (
    <div className={`${className}`}>
      <ClientFooter version={formatVersionString(appVersion)} />
    </div>
  );
};

export default PageFooter;
